/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Selector_Unlock_ModelsInputs */



/**
* | output |
* | --- |
* | "Unlock more models" |
*
* @param {Model_Selector_Unlock_ModelsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_selector_unlock_models = /** @type {((inputs?: Model_Selector_Unlock_ModelsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Selector_Unlock_ModelsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mehr Modelle freischalten")
	return /** @type {LocalizedString} */ ("Unlock more models")
});